import { LocationT } from '../../types/Locations';
import BaseService from '../BaseService';

const castLocations = (locations: Record<string, unknown>[]): LocationT[] => {
  return locations.map((item: Record<string, unknown>) => ({
    id: item.locationId as string,
    type: item.locationType as string,
    name: item.locationName as string,
    personas: Array.isArray(item.personas)
      ? item.personas.map((persona: Record<string, unknown>) => ({
          name: persona.name as string,
          id: persona.personaId as string,
        }))
      : [],
    children: castLocations((item.childLocations || []) as Record<string, unknown>[]),
  }));
};

export default class LocationService extends BaseService {
  async getOrganizationLocations({
    orgId,
    startIndex,
    count,
  }: {
    orgId: string;
    startIndex: number;
    count: number;
  }) {
    const res = await this.host.api.location.getOrganizationLocations({ orgId, startIndex, count });
    try {
      const transformedRes = {
        metadata: {
          firstHit: res.data.startIndex,
          totalHits: res.data.totalResults,
        },
        results: castLocations(res.data.resources),
      };
      return transformedRes;
    } catch (error) {
      return error;
    }
  }

  async updateLocationPersonas({
    orgId,
    locationId,
    locationType,
    associationsToAdd,
    associationsToRemove,
  }: {
    orgId: string;
    locationId: string;
    locationType: string;
    associationsToAdd: string[];
    associationsToRemove: string[];
  }) {
    return await this.host.api.location.updateLocationPersonas({
      orgId,
      locationId,
      locationType,
      associationsToAdd,
      associationsToRemove,
    });
  }

  async getUserLocations({
    accountId,
    orgId,
  }: {
    accountId: string;
    orgId: string;
  }): Promise<{ name: string; children: { name: string }[] }[]> {
    const res = await this.host.api.location.getUserLocations({ accountId, orgId });
    return res.data;
  }
}
